import apiCall from "../../utils/apiCall";
import { apiUrls } from "../../constants/apiUrls";
import type { PlannedScheduleTableRow } from "../../types/api/planRoute/cp.types";

const asRecord = (v: unknown): Record<string, unknown> | null =>
    v !== null && typeof v === "object" ? (v as Record<string, unknown>) : null;

/** Maps API JSON (camelCase or PascalCase) to flat rows for the schedule table. */
export function mapPlannedScheduleToItems(data: unknown): PlannedScheduleTableRow[] {
    const root = asRecord(data);
    if (!root) return [];

    const groupsRaw = root.groups ?? root.Groups;
    if (!Array.isArray(groupsRaw)) return [];

    return groupsRaw.flatMap((g): PlannedScheduleTableRow[] => {
        const gr = asRecord(g);
        if (!gr) return [];

        const geofence = String(gr.geofence ?? gr.Geofence ?? "");
        const itemsRaw = gr.items ?? gr.Items;
        if (!Array.isArray(itemsRaw)) return [];

        return itemsRaw.map((it): PlannedScheduleTableRow => {
            const row = asRecord(it) ?? {};
            const datesRaw = row.plannedDates ?? row.PlannedDates;
            return {
                id: String(row.id ?? row.Id ?? ""),
                cpName: String(row.cpName ?? row.CpName ?? ""),
                plannedDates: Array.isArray(datesRaw) ? datesRaw.map(String) : [],
                geofence,
            };
        });
    });
}

export const cpPickupPlanService = {
    getPlannedSchedule: () => apiCall.get(apiUrls.planRoute.cpPickupPlan.schedule),
};
